exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntextarea[data-v-364c6124] {\n  width: 290px;\n  height: 100px;\n  resize: none;\n  border-radius: 4px;\n  padding: 4px 6px;\n  margin-left: 20px;\n  border-color: #ccc;\n}\n", ""]);

// exports
